// extracted by mini-css-extract-plugin
export default {"container":"_404_container__qRjNb","wrapper":"_404_wrapper__fiP-U","link":"_404_link__AJjuK"};